const Toggle = ({ checked, onChange, label }: { checked: boolean; onChange: (value: boolean) => void; label: string }) => {
    return (
        <div className="flex items-center gap-3">
            <button
                onClick={() => onChange(!checked)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${checked ? 'bg-gradient-purple' : 'bg-gray-300'}`}
            >
                <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${checked ? 'translate-x-5' : 'translate-x-1'}`} />
            </button>
            <label className="text-sm font-medium text-gray-700 cursor-pointer">{label}</label>
        </div>
    );
};

export default Toggle;
